import React from "react";
import { wrapShape } from "react-shape-editor";
import {
    DEFAULT_ANNOTATION_FRAME_COLOR,
    STICKER_SIZE,
    SELECTED_COLOR,
} from "pages/MaterialSpecs/components/PreviewSelector";

const OPACITY = 0.6;
const STICKER_STROKE_WIDTH = "2";
const FRAME_STROKE_WIDTH = "3";

export const AnnotationFrame = wrapShape(({ width, height, extraShapeProps: { color, type, isSelected } }) => {
    const selectedColor = color || DEFAULT_ANNOTATION_FRAME_COLOR;

    return type === "STICKER" ? (
        <rect
            width={STICKER_SIZE}
            height={STICKER_SIZE}
            fill={selectedColor}
            stroke={isSelected ? SELECTED_COLOR : undefined}
            strokeWidth={STICKER_STROKE_WIDTH}
            opacity={OPACITY}
        />
    ) : (
        <rect
            width={width}
            height={height}
            fill={selectedColor}
            stroke={isSelected ? SELECTED_COLOR : undefined}
            strokeWidth={FRAME_STROKE_WIDTH}
            opacity={OPACITY}
        />
    );
});
